"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var HierarchyUtil_1 = require("../util/HierarchyUtil");
var types_1 = require("../types");
var BaseHierarchyUtil_1 = require("./BaseHierarchyUtil");
var PersonHierarchyUtil = /** @class */ (function (_super) {
    __extends(PersonHierarchyUtil, _super);
    function PersonHierarchyUtil() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.canViewNodeName = false;
        _this.labels = {
            breakdownNameLabel: 'Direct Report Breakdown',
            nodeNameLabel: '',
            nodeExternalIdLabel: '',
            nodeDataExternalIdLabel: 'Employee Id',
            nodeDataNameLabel: 'Full Name',
            parentNodeDataNameLabel: 'Manager Name',
            childNodeCountLabel: 'Direct Reports',
        };
        return _this;
    }
    PersonHierarchyUtil.prototype.getNodeDisplayName = function (params) {
        var nodeVm = params.nodeVm, hierarchyEditState = params.hierarchyEditState;
        return this.nodeDisplayName(nodeVm, hierarchyEditState, function (x, personName) { return personName; });
    };
    PersonHierarchyUtil.prototype.showPeopleToggle = function (node) {
        return false;
    };
    PersonHierarchyUtil.prototype.disablePeopleToggle = function (node) {
        return false;
    };
    PersonHierarchyUtil.prototype.indentNodeAtLevel = function (node) {
        return true;
    };
    PersonHierarchyUtil.prototype.getNodeMoveType = function (sourceType, nodeMoveState, replaceDestination, destinationIsOrphan) {
        var move = __assign({ TO_UNPARENTED: types_1.NodeMoveType.MoveToUnparented, OVER: types_1.NodeMoveType.MoveNodeOverNode, UNDER: types_1.NodeMoveType.MoveNodeUnder }, (nodeMoveState === types_1.NodeMoveState.MoveKeepOpen && {
            TO_UNPARENTED: types_1.NodeMoveType.MovePersonToUnparented,
            OVER: types_1.NodeMoveType.MovePersonOverPersonNode,
            UNDER: types_1.NodeMoveType.MovePersonUnderPersonNode,
        }));
        if (replaceDestination) {
            if (destinationIsOrphan) {
                return move['TO_UNPARENTED'];
            }
            return move['OVER'];
        }
        return move['UNDER'];
    };
    PersonHierarchyUtil.prototype.movingNodes = function (nodes, hierarchyEditState) {
        if (!(0, HierarchyUtil_1.isMovingNodes)(hierarchyEditState)) {
            return [];
        }
        var selectedNodeId = hierarchyEditState.selectedNodeId;
        return [nodes[selectedNodeId]];
    };
    PersonHierarchyUtil.prototype.getDescendantNodeCount = function (nodeVm, structureOnlyHierarchy) {
        var count = nodeVm.nodeData ? 1 : 0;
        count += nodeVm.totalRollups !== undefined ? nodeVm.totalRollups : 0;
        return count;
    };
    PersonHierarchyUtil.prototype.getSingleNodeCount = function (nodeVm, structureOnlyHierarchy) {
        return nodeVm.nodeData ? 1 : 0;
    };
    PersonHierarchyUtil.prototype.isLeafNode = function (nodeVm) {
        return (nodeVm.totalRollups === undefined || nodeVm.totalRollups === 0) && (nodeVm.totalOpen === undefined || nodeVm.totalOpen === 0);
    };
    PersonHierarchyUtil.prototype.isOpenNode = function (node) {
        return !node.nodeData;
    };
    PersonHierarchyUtil.prototype.isPlaceholderLocation = function (node) {
        return false;
    };
    return PersonHierarchyUtil;
}(BaseHierarchyUtil_1.BaseHierarchyUtil));
exports.default = PersonHierarchyUtil;
